export const lazyload = (node, { rootMargin = '0px', threshold = 0.1, onIntersect, renderVisible = false }) => {
  let observer;

  const handleIntersect = (entries) => {
    if (entries[0].isIntersecting) {
      onIntersect?.();
      observer.disconnect();
    }
  };

  if (renderVisible) {
    onIntersect?.();
    return;
  }

  observer = new IntersectionObserver(handleIntersect, { rootMargin, threshold });

  observer.observe(node);

  return {
    destroy() {
      observer?.disconnect();
    }
  };
};
